import { useMemo } from "react";

// Lee parámetros UTM de la URL una sola vez y los expone como objeto estable
export default function useUtmParams() {
  return useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      return {
        utm_source: params.get("utm_source") || undefined,
        utm_medium: params.get("utm_medium") || undefined,
        utm_campaign: params.get("utm_campaign") || undefined,
        utm_term: params.get("utm_term") || undefined,
        utm_content: params.get("utm_content") || undefined,
        utm_id: params.get("utm_id") || undefined,
      };
    } catch (_e) {
      return {};
    }
  }, []);
}


